import loadingAnimation from "../../images/Flow 3 (1).json";
import Lottie from "lottie-react";
import "../loader/loader.css";

export default function LoadingSpinner() {
  return (
    <div className="loader-container">
      <div>Loading...</div>
      <Lottie
        animationData={loadingAnimation}
        loop={true}
        className="animation"
      />
    </div>
  );
}
